import { track } from '../../analytics/events';

export const desktopAnalytics = () => ({
  // FORM EVENTS
  form: {
    submitted: () => track('FormSubmitted', {
      formType: 'ADDRESS_INFO',
      formName: 'ADDRESS_INFO',
    }),
  },

  // INPUT EVENTS
  input: {
    familySameLastName: (value) => track('FieldInteracted', {
      userInputField: {
        fieldType: 'RADIO',
        fieldName: 'family-same-last-name',
        fieldLabel: value,
        fieldValue: value,
      },
      formContext: {
        formName: 'ADDRESS_INFO',
      },
    }),
    familyRemaining: (value) => track('FieldInteracted', {
      userInputField: {
        fieldType: 'RADIO',
        fieldName: 'family-remaining',
        fieldLabel: value,
        fieldValue: value,
      },
      formContext: {
        formName: 'ADDRESS_INFO',
      },
    }),
    businessWholeCompany: (value) => track('FieldInteracted', {
      userInputField: {
        fieldType: 'RADIO',
        fieldName: 'business-whole-company',
        fieldLabel: value,
        fieldValue: value,
      },
      formContext: {
        formName: 'ADDRESS_INFO',
      },
    }),
    businessMultipleAddresses: (value) => track('FieldInteracted', {
      userInputField: {
        fieldType: 'RADIO',
        fieldName: 'business-multiple-addresses',
        fieldLabel: value,
        fieldValue: value,
      },
      formContext: {
        formName: 'MOVE_COMBINED',
      },
    }),
    oldZipCode: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'old-zip-code',
        fieldLabel: 'Zip Code',
      },
      formContext: {
        formName: 'ADDRESS_INFO',
      },
    }),
    oldCity: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'old-city',
        fieldLabel: 'City',
      },
      formContext: {
        formName: 'ADDRESS_INFO',
      },
    }),
    oldState: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'DROPDOWN',
        fieldName: 'old-state',
        fieldLabel: 'State',
      },
      formContext: {
        formName: 'ADDRESS_INFO',
      },
    }),
    oldStreet: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'old-street-address',
        fieldLabel: 'Street Address',
      },
      formContext: {
        formName: 'ADDRESS_INFO',
      },
    }),
    oldUrbanizationName: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'old-urbanization-name',
        fieldLabel: 'Urbanization Name',
      },
      formContext: {
        formName: 'ADDRESS_INFO',
      },
    }),
    oldPoBox: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'old-po-box',
        fieldLabel: 'Po Box',
      },
      formContext: {
        formName: 'ADDRESS_INFO',
      },
    }),
    newZipCode: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'new-zip-code',
        fieldLabel: 'Zip Code',
      },
      formContext: {
        formName: 'ADDRESS_INFO',
      },
    }),
    newCity: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'new-city',
        fieldLabel: 'City',
      },
      formContext: {
        formName: 'ADDRESS_INFO',
      },
    }),
    newState: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'DROPDOWN',
        fieldName: 'new-state',
        fieldLabel: 'State',
      },
      formContext: {
        formName: 'ADDRESS_INFO',
      },
    }),
    newStreet: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'new-street-address',
        fieldLabel: 'Street Address',
      },
      formContext: {
        formName: 'ADDRESS_INFO',
      },
    }),
    newUrbanizationName: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'new-urbanization-name',
        fieldLabel: 'Urbanization Name',
      },
      formContext: {
        formName: 'ADDRESS_INFO',
      },
    }),
    newPoBox: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'new-po-box',
        fieldLabel: 'Po Box',
      },
      formContext: {
        formName: 'ADDRESS_INFO',
      },
    }),
    newPrivateMailbox: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'new-private-mailbox',
        fieldLabel: 'Private Mailbox',
      },
      formContext: {
        formName: 'ADDRESS_INFO',
      },
    }),
  },

  // CLICK EVENTS
  click: {
    getStarted: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Get Started',
      },
      actionOutcome: 'SCROLLED',
    }),
    moverType: (value) => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: value,
      },
      actionOutcome: 'MOVER_TYPE',
    }),
    familyModalOpen: () => track('ElementClicked', {
      webElement: {
        elementType: 'RADIO',
        text: '',
      },
      actionOutcome: 'FAMILY_MODAL_OPENED',
    }),
    familyModalClose: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Continue',
      },
      actionOutcome: 'FAMILY_MODAL_CLOSED',
    }),
    businessModalOpen: () => track('ElementClicked', {
      webElement: {
        elementType: 'RADIO',
        text: '',
      },
      actionOutcome: 'BUSINESS_MODAL_OPENED',
    }),
    businessModalClose: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Continue',
      },
      actionOutcome: 'BUSINESS_MODAL_CLOSED',
    }),
    newConstructionModalOpen: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: '',
      },
      actionOutcome: 'NEW_CONSTRUCTION_MODAL_OPENED',
    }),
    newConstructionModalClose: (text) => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text,
      },
      actionOutcome: 'NEW_CONSTRUCTION_MODAL_CLOSED',
    }),
    next: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Next',
      },
      actionOutcome: 'SUBMIT',
    }),
    tooltipMoveType: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'tooltip-move-type',
      },
      actionOutcome: '',
    }),
    tooltipOldAddress: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'tooltip-old-address',
      },
      actionOutcome: '',
    }),
    tooltipNewAddress: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'tooltip-new-address',
      },
      actionOutcome: '',
    }),
    recaptchaVerified: () => track('FieldInteracted', {
      webElement: {
        elementType: 'BUTTON',
        text: 'recaptcha-verified',
      },
      actionOutcome: 'INTERNALLINK',
    }),
  },
});

export const mobileAnalytics = () => ({
  // FORM EVENTS
  form: {
    submitted: () => track('FormSubmitted', {
      formType: 'ADDRESS_INFO',
      formName: 'ADDRESS_INFO',
    }),
  },

  // INPUT EVENTS
  input: {
    familySameLastName: (value) => track('FieldInteracted', {
      userInputField: {
        fieldType: 'RADIO',
        fieldName: 'family-same-last-name',
        fieldLabel: value,
        fieldValue: value,
      },
      formContext: {
        formName: 'ADDRESS_INFO',
      },
    }),
    familyRemaining: (value) => track('FieldInteracted', {
      userInputField: {
        fieldType: 'RADIO',
        fieldName: 'family-remaining',
        fieldLabel: value,
        fieldValue: value,
      },
      formContext: {
        formName: 'ADDRESS_INFO',
      },
    }),
    businessWholeCompany: (value) => track('FieldInteracted', {
      userInputField: {
        fieldType: 'RADIO',
        fieldName: 'business-whole-company',
        fieldLabel: value,
        fieldValue: value,
      },
      formContext: {
        formName: 'ADDRESS_INFO',
      },
    }),
    oldZipCode: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'old-zip-code',
        fieldLabel: 'Zip Code',
      },
      formContext: {
        formName: 'ADDRESS_INFO',
      },
    }),
    oldCity: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'old-city',
        fieldLabel: 'City',
      },
      formContext: {
        formName: 'ADDRESS_INFO',
      },
    }),
    oldState: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'DROPDOWN',
        fieldName: 'old-state',
        fieldLabel: 'State',
      },
      formContext: {
        formName: 'ADDRESS_INFO',
      },
    }),
    oldStreet: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'old-street-address',
        fieldLabel: 'Street Address',
      },
      formContext: {
        formName: 'ADDRESS_INFO',
      },
    }),
    oldUrbanizationName: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'old-urbanization-name',
        fieldLabel: 'Urbanization Name',
      },
      formContext: {
        formName: 'ADDRESS_INFO',
      },
    }),
    oldPoBox: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'old-po-box',
        fieldLabel: 'Po Box',
      },
      formContext: {
        formName: 'ADDRESS_INFO',
      },
    }),
    newZipCode: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'new-zip-code',
        fieldLabel: 'Zip Code',
      },
      formContext: {
        formName: 'ADDRESS_INFO',
      },
    }),
    newCity: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'new-city',
        fieldLabel: 'City',
      },
      formContext: {
        formName: 'ADDRESS_INFO',
      },
    }),
    newState: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'DROPDOWN',
        fieldName: 'new-state',
        fieldLabel: 'State',
      },
      formContext: {
        formName: 'ADDRESS_INFO',
      },
    }),
    newStreet: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'new-street-address',
        fieldLabel: 'Street Address',
      },
      formContext: {
        formName: 'ADDRESS_INFO',
      },
    }),
    newUrbanizationName: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'new-urbanization-name',
        fieldLabel: 'Urbanization Name',
      },
      formContext: {
        formName: 'ADDRESS_INFO',
      },
    }),
    newPoBox: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'new-po-box',
        fieldLabel: 'Po Box',
      },
      formContext: {
        formName: 'ADDRESS_INFO',
      },
    }),
    newPrivateMailbox: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'new-private-mailbox',
        fieldLabel: 'Private Mailbox',
      },
      formContext: {
        formName: 'ADDRESS_INFO',
      },
    }),
  },

  // CLICK EVENTS
  click: {
    // mobile "Disclaimer" click event
    getStarted: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Get Started',
      },
      actionOutcome: 'INTERNALLINK',
    }),
    // other mobile MoveCombined click events
    moverType: (value) => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: value,
      },
      actionOutcome: 'MOVER_TYPE',
    }),
    familyModalOpen: () => track('ElementClicked', {
      webElement: {
        elementType: 'RADIO',
        text: '',
      },
      actionOutcome: 'FAMILY_MODAL_OPENED',
    }),
    familyModalClose: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Continue',
      },
      actionOutcome: 'FAMILY_MODAL_CLOSED',
    }),
    businessModalOpen: () => track('ElementClicked', {
      webElement: {
        elementType: 'RADIO',
        text: '',
      },
      actionOutcome: 'BUSINESS_MODAL_OPENED',
    }),
    newConstructionModalOpen: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: '',
      },
      actionOutcome: 'NEW_CONSTRUCTION_MODAL_OPENED',
    }),
    newConstructionModalClose: (text) => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text,
      },
      actionOutcome: 'NEW_CONSTRUCTION_MODAL_CLOSED',
    }),
    back: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Back',
      },
      actionOutcome: 'INTERNALLINK',
    }),
    next: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Next',
      },
      actionOutcome: 'SUBMIT',
    }),
    tooltipMoveType: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'tooltip-move-type',
      },
      actionOutcome: '',
    }),
    tooltipInformation: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'tooltip-name',
      },
      actionOutcome: '',
    }),
    tooltipForwardType: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'tooltip-forward-type',
      },
      actionOutcome: '',
    }),
    tooltipForwardStartDate: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'tooltip-forward-start-date',
      },
      actionOutcome: '',
    }),
    tooltipOldAddress: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'tooltip-old-address',
      },
      actionOutcome: '',
    }),
    tooltipNewAddress: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'tooltip-new-address',
      },
      actionOutcome: '',
    }),
    recaptchaVerified: () => track('FieldInteracted', {
      webElement: {
        elementType: 'BUTTON',
        text: 'recaptcha-verified',
      },
      actionOutcome: 'INTERNALLINK',
    }),
    tooltipBusinessAddresses: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'tooltip-business-address',
      },
      actionOutcome: '',
    }),
  },
});
